import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { SessionExpiryRedirectService } from "@infra-adapters/services/session-expiry-redirect.service";

export const authErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const sessionExpiry = inject(SessionExpiryRedirectService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const isLoginCall =
          req.url.includes("/authorization/login") ||
          req.url.includes("authorization/login");
        if (!isLoginCall) {
          sessionExpiry.redirectBecauseExpired();
        }
      }
      return throwError(() => error);
    })
  );
};
